<template>
  <div class='init'>
    <Header></Header>
    <div class="init-box">
      <router-view></router-view>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/5101/Header'
import Footer from '@/components/5101/Footer'
export default {
  name:'5101-init',
  components: {Header, Footer},
  data() {
    return {
      
    };
  },
  created() {
    
  },
  methods: {
    
  },
}
</script>
<style lang='less' scoped>
.init-box {
  min-height: calc(100vh - 80px);
}

</style>